import { render, staticRenderFns } from "./ReceiptPrintConfig.vue?vue&type=template&id=acd3c450&scoped=true"
import script from "./ReceiptPrintConfig.vue?vue&type=script&lang=js"
export * from "./ReceiptPrintConfig.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPrintConfig.vue?vue&type=style&index=0&id=acd3c450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd3c450",
  null
  
)

export default component.exports